import React from 'react';
import Button from '@mui/material/Button';

import AlertDialog from '../Shared/AlertDialog';
import CommonDialog from '../Shared/CommonDialog';
import expandColumnHint from '../../assets/images/expand-column-hint.gif';

const TABLE_HINTS_KEY = 'tableHints';
const TABLE_HINT = {
    DOUBLE_CLICK: 'doubleClick'
};

const getHints = () => sessionStorage.hasOwnProperty(TABLE_HINTS_KEY) ?
    JSON.parse(sessionStorage.getItem(TABLE_HINTS_KEY)) :
    { [TABLE_HINT.DOUBLE_CLICK]: true };

const styles = {
    snackbarMessage: {
        marginLeft: 10
    },
    snackbarButton: {
        color: '#fff'
    },
    expandColumnImage: {
        display: 'block',
        width: '100%'
    }
};

const withTableHints = Component =>
    class WithTableHints extends React.PureComponent {
        state = {
            isDoubleClickHintSnackbarShown: true,
            isDoubleClickHintModalShown: false
        };

        constructor(props) {
            super(props);

            this.onShowMore = this.onShowMore.bind(this);
            this.onDisableDoubleClickHint = this.onDisableDoubleClickHint.bind(this);
            this.hideDoubleClickHintSnackbar = this.hideDoubleClickHintSnackbar.bind(this);
            this.showDoubleClickHintModal = this.showDoubleClickHintModal.bind(this);
            this.hideDoubleClickHintModal = this.hideDoubleClickHintModal.bind(this);
        }

        componentDidMount() {
            this.init();
        }

        init() {
            const hints = getHints();

            this.showDoubleClickHintSnackbar(hints.doubleClick);
            WithTableHints.disableDoubleClickHint(hints.doubleClick);
        }

        onShowMore() {
            this.hideDoubleClickHintSnackbar();
            this.showDoubleClickHintModal();
        }

        onDisableDoubleClickHint() {
            WithTableHints.disableDoubleClickHint(false);

            const { isDoubleClickHintSnackbarShown, isDoubleClickHintModalShown } = this.state;

            if (isDoubleClickHintSnackbarShown) {
                this.hideDoubleClickHintSnackbar();
            }

            if (isDoubleClickHintModalShown) {
                this.hideDoubleClickHintModal();
            }
        }

        static disableDoubleClickHint(isDisableHint) {
            sessionStorage.setItem(TABLE_HINTS_KEY, JSON.stringify({ [TABLE_HINT.DOUBLE_CLICK]: isDisableHint }));
        }

        showDoubleClickHintSnackbar(isShowHintSnackbar) {
            this.setState({ isDoubleClickHintSnackbarShown: isShowHintSnackbar });
        }

        hideDoubleClickHintSnackbar(_event, reason) {
            if (reason === 'clickaway') return;

            this.setState({ isDoubleClickHintSnackbarShown: false });
        }

        showDoubleClickHintModal() {
            this.setState({ isDoubleClickHintModalShown: true });
        }

        hideDoubleClickHintModal() {
            this.setState({ isDoubleClickHintModalShown: false });
        }

        render() {
            const { isDoubleClickHintSnackbarShown, isDoubleClickHintModalShown } = this.state;
            const { t } = this.props;

            const actions = [
                {
                    translateId: 'dontShowAgain',
                    onClick: this.onDisableDoubleClickHint
                },
                {
                    translateId: 'ok',
                    onClick: this.hideDoubleClickHintModal,
                    variant: 'contained',
                }
            ];

            return (
                <React.Fragment>
                    <AlertDialog
                        open={isDoubleClickHintSnackbarShown}
                        variant="info"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        autoHideDuration={10000}
                        message={(
                            <div>
                                <span style={styles.snackbarMessage}>
                                    {t('doubleClickExpandValueColumn')}
                                </span>
                                <div style={styles.snackbarActionsContainer}>
                                    <Button
                                        style={styles.snackbarButton}
                                        onClick={this.onDisableDoubleClickHint}
                                    >
                                        {t('dontShowAgain')}
                                    </Button>
                                    <Button
                                        style={styles.snackbarButton}
                                        onClick={this.onShowMore}
                                    >
                                        {t('moreDetails')}
                                    </Button>
                                </div>
                            </div>
                        )}
                        onClose={this.hideDoubleClickHintSnackbar}
                    />
                    <CommonDialog
                        open={isDoubleClickHintModalShown}
                        title={t('doubleClickExpandValueColumn')}
                        actions={actions}
                        maxWidth="sm"
                        onClose={this.hideDoubleClickHintModal}
                        t={t}
                    >
                        <img
                            src={expandColumnHint}
                            alt="Double click to expand the column"
                            style={styles.expandColumnImage}
                        />
                    </CommonDialog>
                    <Component {...this.props} />
                </React.Fragment>
            );
        }
    };

export default withTableHints;
